<template>
    <div class="page-banner">
        <div class="page-banner__wrapper" :class="{'page-banner-small': small}" :style="`background-image: url(${computedBanner})`">
            <div class="page-banner__bread-crumbs" v-if="$slots['bread-crumbs']">
                <slot name="bread-crumbs" />
            </div>
            <div class="page-banner__content">
                <div class="page-banner__title" v-if="$slots.title">
                    <slot name="title" />
                </div>
                <div class="page-banner__subtitle _mt-16-8" v-if="$slots.subtitle">
                    <slot name="subtitle" />
                </div>
                <div class="page-banner__action _mt-24" v-if="$slots.action && !isMob">
                    <slot name="action" />
                </div>
            </div>
        </div>
        <div class="page-banner__action _mt-24" v-if="$slots.action && isMob">
            <slot name="action" />
        </div>
    </div>
</template>

<script>
import isMob from "../../assets/js/vue/mixins/isMob"
export default {
    name: 'PageBanner',
    mixins: [isMob],
    props: {
        banner: {
            type: String,
            require: true
        },
        bannerMob: {
            type: String,
            require: true
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isMobile: false,
        }
    },
    computed: {
        isMob() {
            return this.windowWidth <= 1000;
        },
        computedBanner() {
            if ( location.pathname.match('/deposits/.*/(3-months|6-months|1-year|3-years)/') ) {
                return this.isMob ? '/upload/images/banners/deposits/special/banner-term_mob.webp' : '/upload/images/banners/deposits/special/banner-term.webp';
            }
            if ( location.pathname.match('/deposits/.*/(dlya-pensionerov|do-vostrebovaniya)/') ) {
                return this.isMob ? '/upload/images/banners/deposits/banner-full_mob.webp' : '/upload/images/banners/deposits/banner-full.webp';
            }
            return this.isMob ? this.bannerMob : this.banner;
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/base/_variables.scss';
@import '../../assets/scss/base/_mixins.scss';
@import '../../assets/scss/base/_functions.scss';

$b: '.page-banner';

#{$b} {

    &__wrapper {
        position: relative;
        @include fluid('width', $base-case, $mobile-case);
        @include fluid('height', 460px, 364px);
        background-size: contain;
        background-repeat: no-repeat;
        @include fluid('padding-top', 32px);
        @include fluid('padding-left', 49px, 19px);
        @include fluid('padding-right', 0, 19px);
        @include fluid('border-radius', 40px, 24px);
        overflow: hidden;
    }

    &-small {
        @include fluid('height', 300px, 300px);
    }

    &__bread-crumbs {
        @include fluid('margin-bottom', 56px, 0);

        @include mobile {
            display: none;
        }
    }

    &__content {
        @include fluid('width', 592px, 290px);
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}
</style>
